import { useMemo } from "react";
import { UseQueryResult } from "react-query";
import { RemoteRoomlayout } from "../../../../components/FacilityManager/Domain/Types/FloorPlan/RoomlayoutAssignment.type";
import { RemoteApiError } from "../../useRemote/types";
import { useRemoteQuery } from "../../useRemote/useRemoteQuery";
import { mapRemoteRoomlayoutRowVal } from "../../../../components/ServiceManagement/Roomlayout/helpers/mapRemoteRoomlayoutRowVal.function";

/**
 * type of remote room layout
 * @implements row : boolean[][] needs to convert
 * @example [{ "row": [false,false,true,false] }, { "row": [false,false,true,false] },{ "row": [false,false,true,false] },{ "row": [false,false,true,false] }]
 */
export type RemoteRoomlayoutRows = Omit<RemoteRoomlayout, "arrangement"> & {
  arrangement: Array<{ row: boolean[] }>;
};

export function useRemoteFetchRoomlayout(
  enabled?: boolean
): UseQueryResult<RemoteRoomlayout[], RemoteApiError> {
  const queryResult = useRemoteQuery<(RemoteRoomlayout | RemoteRoomlayoutRows)[], RemoteApiError>({
    queryKey: ["conferenceroom", "room-layouts"],
    url: `/room-layouts`,
    enabled: enabled ?? true
  });

  const normalizedData = useMemo(() => {
    if (!queryResult.data) return undefined;
    return queryResult.data.map(mapRemoteRoomlayoutRowVal);
  }, [queryResult.data]);

  return { ...queryResult, data: normalizedData } as UseQueryResult<
    RemoteRoomlayout[],
    RemoteApiError
  >;
}
